var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-body',{staticClass:"p-0",staticStyle:{"position":"relative"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }